const updateWeekNumbers = (clonePhases: any) => {
  let num = 0;
  clonePhases.forEach((phase: any) => {
    if (phase.weeks && phase.weeks.length) {
      phase.weeks.forEach((week: any) => {
        week.weekNo = ++num;
      });
    }
  });
};

export default updateWeekNumbers;
